import React from "react";
import { connect } from "react-redux";
import {
  getContactData,
  getContactDataFields,
  getContactValues
} from "Portal/NewPortal/FollowupForm/selectors";
import { getters, actions } from "Portal/NewPortal/FollowupForm/model";
import InputFields from "./InputFields";
import * as STANDARD_MODULE_FIELD_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-module-field-ids";

const decorate = connect(
  state => ({
    error: getters.error(state),
    emailError: getters.emailError(state),
    data: getContactData(state),
    contactValues: getContactValues(state),
    contactDataFields: getContactDataFields(state)
  }),
  {
    updateContactValues: actions.updateContactValues,
    verifyEmail: actions.verifyEmail
  }
);

const ContactPage = ({
  handlers,
  error,
  emailError,
  data,
  updateContactValues,
  contactValues,
  contactDataFields,
  verifyEmail
}) => {
  const updateAndVerifyValue = data => {
    updateContactValues(data);
    if (data.id === STANDARD_MODULE_FIELD_IDS.CONTACTS.EMAIL) {
      verifyEmail(data.value.value);
    }
  };
  return (
    <InputFields
      disableShowAlert
      handlers={handlers}
      error={error}
      data={data}
      values={contactValues}
      updateValues={updateAndVerifyValue}
      fields={contactDataFields}
      emailError={emailError}
    ></InputFields>
  );
};

export default decorate(ContactPage);
